import React from "react";
import { Switch, Redirect } from "react-router";
import { Route } from "react-router-dom";

import ProfileMembership from "@profile/pages/MembershipPage/MembershipPage";
import MyCompaniesPage from "./pages/MyCompaniesPage/MyCompaniesPage";
import PageFromRails from "./components/PageFromRails/PageFromRails";

import IProfileApp from "./IProfileApp";
import ProfileSubmenu from "./components/ProfileSubmenu/ProfileSubmenu";
import { AccountPage } from "./pages/AccountPage/AccountPage";
import PortfolioApp from "@apps/PortfolioApp/PortfolioApp";
import CelsiusClaimPage from "./pages/CelsiusClaimPage/CelsiusClaimPage";
import FundsApp from "@funds/index";
import StakeForm from "@funds/pages/MyFunds/pages/StakingPage/parts/StakeForm/StakeForm";
import UnstakeForm from "@funds/pages/MyFunds/pages/StakingPage/parts/UnstakeForm/UnstakeForm";
import {
  FUNDS_PENDING_STAKED_ETH,
  FUNDS_STAKING_FORM,
  FUNDS_TIMELOCK_STAKING_FORM,
  FUNDS_UNSTAKING_FORM,
} from "@funds/config";
import PendingStakedEth from "@funds/pages/MyFunds/pages/StakingPage/parts/PendingStakedEth";
import TimelockStakeForm from "@funds/pages/MyFunds/pages/StakingPage/parts/TimelockStakeForm/TimelockStakeForm";
import SharesApp from "@profile/pages/SharesPage/SharesPage";
import {
  REQUEST_TO_SELL_SHARES_URL,
  SHARES_URL,
} from "@profile/pages/SharesPage/config";
import RequestToSellPage from "./pages/SharesPage/pages/RequestToSellPage/RequestToSellPage";

export class ProfileApp extends React.Component<IProfileApp, {}> {
  render() {
    const { profile, match } = this.props;
    const unstakingEnabled = process.env.UNSTAKING_ENABLED;
    const pagesFromRails = `security|pitches${
      process.env["ENABLE_PORTFOLIO"] ? "" : "|portfolio"
    }`;

    return (
      <div>
        <Switch>
          <Route
            exact={true}
            path={`${match.path}/membership`}
            render={() => (
              <ProfileMembership
                profile={profile}
                transaction_url={this.props.transaction_url}
                isPremium={this.props.isPremium}
              />
            )}
          />
          <Route
            exact={true}
            path={`${match.path}/chapter-11-claim`}
            render={() => <CelsiusClaimPage />}
          />

          {unstakingEnabled && (
            <Route
              exact={true}
              path={`${match.path}/funds/${FUNDS_UNSTAKING_FORM}`}
              render={(props) => (
                <UnstakeForm currency={"staked_eth"} history={props.history} />
              )}
            />
          )}

          <Route
            exact={true}
            path={`${match.path}/funds/${FUNDS_PENDING_STAKED_ETH}`}
            render={(props) => <PendingStakedEth {...props} />}
          />

          <Route
            exact={true}
            path={`${match.path}/funds/${FUNDS_TIMELOCK_STAKING_FORM}`}
            render={(props) => (
              <TimelockStakeForm currency={"eth"} history={props.history} />
            )}
          />

          <Route
            exact={true}
            path={`${match.path}/funds/${FUNDS_STAKING_FORM}`}
            render={(props) => (
              <StakeForm currency={"eth"} history={props.history} />
            )}
          />

          <Route
            exact={true}
            path={`${match.path}/funds/:subpage?/:action?`}
            render={(props) => <FundsApp {...props} />}
          />

          <Route
            exact={true}
            path={`${match.path}/companies`}
            render={(props) => (
              <MyCompaniesPage
                slug={this.props.slug}
                profileId={this.props.profileId}
              />
            )}
          />
          <Route
            exact={true}
            path={`${match.path}/account`}
            render={() => <AccountPage {...this.props} />}
          />
          <Route
            exact={true}
            path={`${match.path}${SHARES_URL}`}
            render={() => {
              return <SharesApp />;
            }}
          />

          <Route
            exact={true}
            path={`${match.path}${SHARES_URL}${REQUEST_TO_SELL_SHARES_URL}`}
            render={() => <RequestToSellPage />}
          />

          <Route
            exact={true}
            path={`${match.path}${SHARES_URL}/:subpage`}
            render={() => <SharesApp />}
          />

          {process.env["ENABLE_PORTFOLIO"] && (
            <Route
              path={`${match.path}/portfolio/:subpage?`}
              render={(props) => <PortfolioApp {...props} />}
            />
          )}
          <Route
            exact={true}
            path={`${match.path}/:action(${pagesFromRails})`}
            render={(props) => (
              <PageFromRails {...props} key={props.match.params.action} />
            )}
          />
          <Redirect from={match.path} to={`${match.path}/membership`} />
        </Switch>
      </div>
    );
  }
}

export default ProfileApp;
